export * from './loyalty-greeting-widget.styled.default';
